import { CREDENTIALS_ROUTES } from './constants';
import CredentialsListsLayout from './components/CredentialsListsLayout';

export default [
    {
        path: CREDENTIALS_ROUTES.LIST,
        component: CredentialsListsLayout
    }
];
